import ClixChart from "./clix-chart";

export default ClixChart;